// External
import React, { useState } from 'react';
import { object, func } from 'prop-types';
import { Box, Flex } from 'rebass';
import { Plus, CopyPaste } from '@nike/nike-design-system-icons';
import { connect } from 'react-redux';

import CatalogTypeBadge from '../../catalogTypes/CatalogTypeBadge';

import { saveAdminDepartmentCatalogTypes as saveCatalogTypes } from '../actions';

const CatalogTypeTableCell = ({
  department,
  setSelectedDepartments,
  setSelectedCatalogType,
  openAddCatalogTypeModal,
  openRemoveCatalogTypeModal
}) => {
  const [copied, setCopied] = useState(false);

  const disassociateCatalogTypeClick = catalogType => {
    setSelectedCatalogType(catalogType);
    setSelectedDepartments([department]);
    openRemoveCatalogTypeModal();
  };

  const handleAddCatalogTypeClick = () => {
    setSelectedDepartments([department]);
    openAddCatalogTypeModal();
  };

  const handleCopyCatalogTypes = () => {
    const catalogTypeNames = department.catalogTypes?.map(ct => ct.name).join(', ') || '';
    navigator.clipboard.writeText(catalogTypeNames).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <>
      <Box height='100%' width='100%' style={{ overflowY: 'scroll' }}>
        <Flex width='100%'>
          <Flex width='100%' flexWrap='wrap'>
            {department.catalogTypes?.map(catalogType => (
              <CatalogTypeBadge
                key={catalogType.id}
                catalogType={catalogType}
                disassociateCatalogType={disassociateCatalogTypeClick}
                width='30%'
              />
            ))}
          </Flex>

          <Flex flexDirection='column' mr='5px' alignItems='center'>
            <Box onClick={handleAddCatalogTypeClick} style={{ cursor: 'pointer' }}>
              <Plus size='m' data-testid='addCatalogType' />
            </Box>
            <Box
              onClick={handleCopyCatalogTypes}
              style={{ cursor: 'pointer', opacity: copied ? 0.5 : 1 }}
              title={copied ? 'Copied!' : 'Copy catalog types'}
            >
              <CopyPaste size='m' data-testid='copyCatalogTypes' />
            </Box>
          </Flex>
        </Flex>
      </Box>
    </>
  );
};

CatalogTypeTableCell.defaultProps = {
  department: {}
};

CatalogTypeTableCell.propTypes = {
  department: object,
  setSelectedDepartments: func.isRequired,
  setSelectedCatalogType: func.isRequired,
  openRemoveCatalogTypeModal: func.isRequired,
  openAddCatalogTypeModal: func.isRequired
};

export default connect(null, { saveCatalogTypes })(CatalogTypeTableCell);
